module.exports = __webpack_public_path__ + "img/a2_sidebar.452abf42.png";